import { Assert } from '@aura/core-lib';
import type { LfProviderThemesProps } from '@lift/ds-web/components/LfProvider/LfProvider.types';
import configEstacio from './estacio';
import configIbmec from './ibmec';
import configIdomed from './idomed';
import { Environment } from './types';
import configWyden from './wyden';

import * as EstacioDefault from '@lift/ds-tokens/brands/estacio/ts/default.js';
import * as EstacioAltoConstraste from '@lift/ds-tokens/brands/estacio/ts/high-contrast.js';
import * as IbmecDefault from '@lift/ds-tokens/brands/ibmec/ts/default.js';
import * as IbmecAltoConstraste from '@lift/ds-tokens/brands/ibmec/ts/high-contrast.js';
import * as IdomedDefault from '@lift/ds-tokens/brands/idomed/ts/default.js';
import * as IdomedAltoConstraste from '@lift/ds-tokens/brands/idomed/ts/high-contrast.js';
import * as WydenDefault from '@lift/ds-tokens/brands/wyden/ts/default.js';
import * as WydenAltoConstraste from '@lift/ds-tokens/brands/wyden/ts/high-contrast.js';

const environments: Array<() => Environment> = [
  configEstacio.prod,
  configIbmec.prod,
  configWyden.prod,
  configIdomed.prod,
  configEstacio.local,
  configIbmec.local,
  configWyden.local,
  configIdomed.local,
  configEstacio.browserStack,
  configEstacio.dev,
  configIbmec.dev,
  configWyden.dev,
  configIdomed.dev,
  configEstacio.hml,
  configIbmec.hml,
  configWyden.hml,
  configIdomed.hml,
];

export const getConfig = (): Environment => {
  const contextoAtual = `${window.location.protocol}//${window.location.host}`;
  const env = environments.map((env) => env()).find((env) => env.contextos.some((ctx) => ctx.host === contextoAtual));

  Assert.nonNullable(env);

  return env;
};

export const TEMA_LIFT_V2: LfProviderThemesProps = {
  estacio: {
    default: EstacioDefault,
    'high-contrast': EstacioAltoConstraste,
  },
  wyden: {
    default: WydenDefault,
    'high-contrast': WydenAltoConstraste,
  },
  ibmec: {
    default: IbmecDefault,
    'high-contrast': IbmecAltoConstraste,
  },
  idomed: {
    default: IdomedDefault,
    'high-contrast': IdomedAltoConstraste,
  },
};
